import { render, staticRenderFns } from "./TermsAndConditionsModal.vue?vue&type=template&id=158bc1ce&scoped=true&"
import script from "./TermsAndConditionsModal.vue?vue&type=script&lang=js&"
export * from "./TermsAndConditionsModal.vue?vue&type=script&lang=js&"
import style0 from "./TermsAndConditionsModal.vue?vue&type=style&index=0&id=158bc1ce&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158bc1ce",
  null
  
)

export default component.exports